import clsx from "clsx";
import React from "react";

const TrafficSignalPill = ({
  stopped,
  text,
  stoppedText,
}: {
  stopped?: boolean;
  text?: string;
  stoppedText?: string;
}) => {
  const lastChecked = new Date(Date.now() - 43 * 1000);

  return (
    <div className="flex items-center gap-2 px-2 py-1 rounded-md bg-transparent text-white text-xs">
      <div className="leading-tight">
        <div className="flex items-center gap-2 ">
          <div className="relative ">
            {!stopped && (
              <div
                className={clsx(
                  `absolute top-0 bottom-0 m-auto left-0 w-2 h-2 rounded-full animate-ping opacity-75`,
                  stopped ? " bg-red-400" : "bg-green-400"
                )}
              ></div>
            )}
            <div
              className={clsx(
                `relative w-2 h-2  top-0 bottom-0 m-auto rounded-full`,
                stopped ? " bg-red-400" : "bg-green-400"
              )}
            ></div>
          </div>
          <p className="font-medium text-base">
            {stopped ? stoppedText : text}
          </p>
        </div>
      </div>
    </div>
  );
};

export default TrafficSignalPill;
